import React, { memo } from 'react';
import { BaseEdge, getBezierPath, Position } from 'reactflow';

export interface ADEdgeProps {
    id: string;
    sourceX: number;
    sourceY: number;
    targetX: number;
    targetY: number;
    sourcePosition?: Position;
    targetPosition?: Position;
    style?: React.CSSProperties;
    markerEnd?: string;
}

export const ADEdge = memo(({
    sourceX, sourceY, targetX, targetY, sourcePosition = Position.Bottom, targetPosition = Position.Top, style = {}, markerEnd
}: ADEdgeProps) => {
    const [edgePath] = getBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });

    const isHighlight = (style as any)?.stroke === '#f97316' || (style as any)?.stroke === '#3b82f6';
    const strokeColor = (style as any)?.stroke || '#3b82f6';

    return (
        <>
            {/* Ambient Outer Glow */}
            <path
                d={edgePath}
                fill="none"
                stroke={strokeColor}
                strokeWidth={isHighlight ? 7 : 4}
                opacity={0.18}
                strokeLinecap="round"
            />
            {/* Core Edge Line */}
            <BaseEdge
                path={edgePath}
                markerEnd={markerEnd}
                style={{
                    ...style,
                    strokeWidth: isHighlight ? 2 : 1.5,
                    opacity: 0.85,
                }}
            />
        </>
    );
});

ADEdge.displayName = 'ADEdge';
export default ADEdge;
